import { useEffect, useRef } from 'react';
import { useLiveCall } from '../../context/LiveCallContext';
import { Bot, User } from 'lucide-react';

export function StreamingTranscript() {
  const { liveTranscriptLines } = useLiveCall();
  const transcriptEndRef = useRef(null);

  useEffect(() => {
    transcriptEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [liveTranscriptLines]);

  if (!liveTranscriptLines || liveTranscriptLines.length === 0) {
    return (
      <div className="h-full flex flex-col items-center justify-center text-slate-400 p-8 text-center">
        <Bot className="w-8 h-8 mb-3 text-slate-300" />
        <p>Transcription will appear here once the conversation starts.</p>
      </div>
    );
  }

  return (
    <div className="h-full overflow-y-auto space-y-4 pr-2">
      {liveTranscriptLines.map((line, idx) => {
        const isAgent = line.role === 'agent';
        return (
          <div key={idx} className={`flex gap-3 ${isAgent ? '' : 'flex-row-reverse'}`}>
            <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${
              isAgent ? 'bg-violet-100 text-violet-600' : 'bg-blue-100 text-blue-600'
            }`}>
              {isAgent ? <Bot className="w-4 h-4" /> : <User className="w-4 h-4" />}
            </div>
            <div className={`max-w-[80%] rounded-2xl p-3 text-sm shadow-sm ${
              isAgent 
                ? 'bg-white border border-slate-200 text-slate-700 rounded-tl-none' 
                : 'bg-blue-600 text-white rounded-tr-none'
            }`}>
              {line.content}
            </div>
          </div>
        );
      })}
      <div ref={transcriptEndRef} />
    </div>
  );
}
